import { useDispatch } from "react-redux";
import { API } from "../constants/api";
import { axiosPostWithToken, axiosPut } from "../services/apiServices";

import {
  CORPORATES_PENDING_REVIEW_LIST,
  CORPORATES_REJECTED_REVIEW_LIST,
  CORPORATES_REVIEW_END_DATE,
  CORPORATES_REVIEW_PAGE_ID,
  CORPORATES_REVIEW_PUBLISHED_LIST,
  CORPORATES_REVIEW_START_DATE,
  IS_CORP_DATA_LOADING,
} from "./types";

export const getCorporateReviewPendingList = (page) => {
  

  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const body = {
      "next_page_id": page,
      "page_size":10,
      "filters":[{"field":"status", "value":"pending"}],
      "sort":{"field":"modified", "order":"D"}
  }
  dispatch({
    type: IS_CORP_DATA_LOADING,
    payload: true,
  });
    axiosPostWithToken(`${API.GET_CORPORATES_REVIEW_LIST}`, body, token)
      .then((res) => {
        console.log(res.data.status_code)
        if (res.data.status_code === 200) {
          dispatch({
            type: CORPORATES_PENDING_REVIEW_LIST,
            payload: res.data.data,
          });
          dispatch({
            type: IS_CORP_DATA_LOADING,
            payload: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: IS_CORP_DATA_LOADING,
          payload: false,
        });
      });
  };
};
export const getCorporateReviewRejectedList = (page) => {
  

  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const body = {
      "next_page_id": page,
      "page_size":10,
      "filters":[{"field":"status", "value":"rejected"}],
      "sort":{"field":"modified", "order":"D"}
  }
  dispatch({
    type: IS_CORP_DATA_LOADING,
    payload: true,
  });
    axiosPostWithToken(`${API.GET_CORPORATES_REVIEW_LIST}`, body, token)
      .then((res) => {
        console.log(res.data.status_code)
        if (res.data.status_code === 200) {
          dispatch({
            type: CORPORATES_REJECTED_REVIEW_LIST,
            payload: res.data.data,
          });
          dispatch({
            type: IS_CORP_DATA_LOADING,
            payload: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: IS_CORP_DATA_LOADING,
          payload: false,
        });
      });
  };
};
export const getCorporateReviewPublishedList = (page) => {
  

  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const body = {
      "next_page_id": page,
      "page_size":10,
      "filters":[{"field":"status", "value":"approved"}],
      "sort":{"field":"modified", "order":"D"}
  }
  dispatch({
    type: IS_CORP_DATA_LOADING,
    payload: true,
  });
    axiosPostWithToken(`${API.GET_CORPORATES_REVIEW_LIST}`, body, token)
      .then((res) => {
        console.log(res);
        if (res.data.status_code === 200) {
          dispatch({
            type: CORPORATES_REVIEW_PUBLISHED_LIST,
            payload: res.data.data,
          });
          dispatch({
            type: IS_CORP_DATA_LOADING,
            payload: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: IS_CORP_DATA_LOADING,
          payload: false,
        });
      });
  };
};
export const getCorporateReviewsearch = (page, status, startDate, endDate) => {
    return async (dispatch, getState) => {
      const token = getState().auth.token;
      const body = {
        "next_page_id": 1,
        "page_size":10,
        "filters":[{"field":"status", "value":status},{"field":"from", "value":startDate},{"field":"to", "value":endDate}],
        "sort":{"field":"modified", "order":"D"}
    }
    dispatch({
      type: IS_CORP_DATA_LOADING,
      payload: true,
    });
      axiosPostWithToken(`${API.GET_CORPORATES_REVIEW_LIST}`, body, token)
        .then((res) => {
          console.log(res);
          if (res.data.status_code === 200) {
            if (status == "approved") {
              dispatch({
                type: CORPORATES_REVIEW_PUBLISHED_LIST,
                payload: res.data.data,
              });
            }else if(status=="rejected"){
              dispatch({
                type: CORPORATES_REJECTED_REVIEW_LIST,
                payload: res.data.data,
              });
            }
             else {
              dispatch({
                type: CORPORATES_PENDING_REVIEW_LIST,
                payload: res.data.data,
              });
            }
            dispatch({
              type: IS_CORP_DATA_LOADING,
              payload: false,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          dispatch({
            type: IS_CORP_DATA_LOADING,
            payload: false,
          });
        });
    };
  };
export const CorporateReviewStatusUpdate = (
  status,
  main_pack_id,
  review_id,
  ref_id,
  refreshData
) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const body = {
      status: status,
      main_pack_id: main_pack_id,
      review_id: review_id,
      ref_id: ref_id,
    };
    axiosPut(`${API.CORPORATES_REVIEW_STATUS_UPDATE}`, body, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          refreshData();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
};
export const myCorporateReviewStartDate = (date) => {
    
    return async (dispatch) => {
      dispatch({
        type: CORPORATES_REVIEW_START_DATE,
        payload: date,
      });
    };
  };
  
  export const myCorporateReviewEndDate = (date) => {
    return async (dispatch) => {
      dispatch({
        type: CORPORATES_REVIEW_END_DATE,
        payload: date,
      });
    };
  };
export const reviewPageId = (page) => {
  return async (dispatch) => {
    dispatch({
      type: CORPORATES_REVIEW_PAGE_ID,
      payload: page,
    });
  };
};
